import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

const StyledDDContainer = styled.div`
    position: relative;
`;

export const StyledBaseDropdownButtonWrap = styled.div<{ isEmpty: boolean }>`
    width: 100%;

    & .DropdownButton {
        background-color: ${colorsPalettes.carbon["0"]};
        border-color: ${colorsPalettes.midnight["50"]};
        box-sizing: border-box;
        color: ${({ isEmpty }) => (isEmpty ? colorsPalettes.carbon[200] : colorsPalettes.carbon[400])};
        height: 40px;
        position: relative;
    }

    & .DropdownButton:active {
        background-color: ${colorsPalettes.carbon["0"]};

        .DropdownButton--triangle {
            color: ${colorsPalettes.carbon["400"]};
        }
    }
`;

export const StyledDropdownContainer = styled.div<{ $width: string }>`
    position: relative;
    width: ${({ $width }) => $width};
`;
